import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import'./Users.css'
import { Link } from 'react-router-dom';

function Users() {
    const [data , setData] = useState([])
    const [loading, setLoading] = useState(true);
    console.log(data);
    
  
  
  useEffect(()=>{
    async function featchUser(){
      try {
        setLoading(true); // Start loading
        const response = await fetch('https://us-central1-fabdiz-quote.cloudfunctions.net/api/Users');
        if(!response.ok){
          throw new Error('failed to fetch users');
        }
        const data = await response.json();
        setData(data);
        setLoading(false);
      } catch (error) {
        console.log(error.message); 
        setLoading(false);
      }
    }
    featchUser();
  },[])


  
  return(
    <div>
    <div className='adminHeader' >
      <h2> Users</h2>
    </div>
    <div className='adminHeader1' >
      <div>
      <h2>Users</h2>
      </div>
      <div className='adminHeader1button' >
        <button className='buttonDesign' >
          Add User
        </button>
      </div>
    </div>
    <hr/>
    <div>
    <div>
    <div className="table-container">
  {loading ? (
    <div className="loader">Loading...</div>
  ) : data && data.length > 0 ? (
    <div className="tableScroll">
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Designation</th>
            <th>Mobile</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>{item.name}</td>
              <td>{item.email}</td>
              <td>{item.designation}</td>
              <td>{item.mobile}</td>
              <td><Link to={`/admin-dashboard/users/ViewUserDetail/${item.id}`} ><button className='buttonDesign'  >View</button></Link></td>
              <td><button className='buttonDesign'>Delete</button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : (
    <div className='noDataFound' >No data available</div>
  )}
</div>


    </div>
   </div>

        

  </div>
  )
}

export default Users;
